import { render, staticRenderFns } from "./d-post-poll-multiple-choice.vue?vue&type=template&id=3420db38&scoped=true&"
import script from "./d-post-poll-multiple-choice.vue?vue&type=script&lang=js&"
export * from "./d-post-poll-multiple-choice.vue?vue&type=script&lang=js&"
import style0 from "./d-post-poll-multiple-choice.vue?vue&type=style&index=0&id=3420db38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3420db38",
  null
  
)

export default component.exports